<template>
    <div>
        <order :order-id="$route.params.id"></order>
    </div>
</template>


<script>
    import {mapGetters} from "vuex"
    export default {
        name: 'order-view',
        data() {
            return {}
        }
    };
</script>



// WEBPACK FOOTER //
// OrderView.vue?8787b3d6